export const ROLE_ADMIN = 'ADMIN';
export const ROLE_MANAGER = 'MANAGER';
export const ROLE_TEAM_LEAD = 'TEAM_LEAD';
export const ROLE_EMPLOYEE = 'EMPLOYEE';
export const ROLE_PARTNER = 'PARTNER';
